import FileField from './FileField';

export default FileField;
